import { StyleSheet } from 'aphrodite';
import emailGraphicImg from '../../../../assets/email_graphic.svg';
import exchangeLogoImg from '../../../../assets/exchange_logo.png';
import googleLogoLgImg from '../../../../assets/google_logo_large.png';
import office365Img from '../../../../assets/office_365_logo.png';
import { titles } from '../../../../styles/colors';
import { CssSelectors } from '../../../../styles/styles';

export const styleSheet = StyleSheet.create({
	container: {
		position: 'relative',
	},
	exchangeLogo: {
		backgroundImage: `url(${exchangeLogoImg})`,
		backgroundPosition: 'center center',
		backgroundRepeat: 'no-repeat',
		backgroundSize: 171,
		display: 'block',
		height: 53,
		margin: '20px 0 20px 0',
		width: 171,
	},
	footer: {
		marginTop: 20,
		display: 'flex',
		...CssSelectors.allChildren(
			{
				marginLeft: 10,
			},
			':not(:first-child)'
		),
	},
	genericEmailLogo: {
		backgroundImage: `url(${emailGraphicImg})`,
		backgroundPosition: 'center center',
		backgroundRepeat: 'no-repeat',
		backgroundSize: 97,
		display: 'block',
		height: 97,
		margin: '20px 0 20px 0',
		width: 97,
	},
	googleLogo: {
		backgroundImage: `url(${googleLogoLgImg})`,
		backgroundPosition: 'center center',
		backgroundRepeat: 'no-repeat',
		backgroundSize: 140,
		display: 'block',
		height: 47,
		margin: '20px 0 20px 0',
		width: 140,
	},
	importNow: {},
	importNowButton: {
		marginTop: 20,
	},
	importNowRadioButtons: {
		marginBottom: 20,
	},
	o365Logo: {
		backgroundImage: `url(${office365Img})`,
		backgroundPosition: 'center center',
		backgroundRepeat: 'no-repeat',
		backgroundSize: 140,
		display: 'block',
		height: 47,
		margin: '20px 0 20px 0',
		width: 140,
	},
	secondaryMessage: {
		color: '#858585',
		fontSize: 14,
		lineHeight: '22px',
	},
	sections: {
		...CssSelectors.allChildren(
			{
				marginTop: 28,
			},
			':not(:first-child)'
		),
	},
	sectionSubHeader: {
		color: titles,
		fontSize: '0.875rem',
		marginTop: '0.5rem 0 2rem',
	},
});
